var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00766 16.8038H3.48195C2.20613 16.8038 1.17188 15.7695 1.17188 14.4937V7.06598C1.17188 5.79016 2.20613 4.7559 3.48195 4.7559H13.5044C14.7802 4.7559 15.8145 5.79016 15.8145 7.06598V9.24723M1.62816 9.57223H15.3582M5.06898 9.69355V11.2195M12.1867 13.1776H15.9586M12.1867 16.3126H15.9586M11.2342 4.7559H5.75219V3.23203C5.75219 2.26465 6.53641 1.48047 7.50375 1.48047H9.48266C10.45 1.48047 11.2342 2.26469 11.2342 3.23203V4.7559ZM18.8281 11.2091C18.8281 10.3051 18.0953 9.57223 17.1913 9.57223H10.9541C10.0501 9.57223 9.31723 10.3051 9.31723 11.2091V18.2811C9.31723 19.1851 10.0501 19.918 10.9541 19.918H17.1913C18.0953 19.918 18.8281 19.1851 18.8281 18.2811V11.2091Z",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon);
export default __webpack_public_path__ + "static/media/portfolioIcon.42eb464d56de4ea886ffd802b6c8303f.svg";
export { ForwardRef as ReactComponent };